<template>
  <base-modal :size="'xl'" :modal-id="'filter-selection-modal'" :is-modal-open="isOpen" hide-footer @hide="onCloseModal">
    <template #modal-header>
      <div class="filter-selection-header-wrp">
        <div class="left-wrp">
          <div class="title-wrp">
            {{ 'เเหล่งที่มาของข้อมูล' }}
          </div>
          <div class="title-desc-wrp">
            {{ 'กรุณาเลือกเเหล่งที่มาของข้อมูล' }}
          </div>
        </div>
        <div class="right-wrp">
          <div class="counter-wrp">
            <span>เลือกแล้ว {{ totalSelected.valueOf() }}</span
            ><span>/{{ totalOptions() }}</span>
          </div>
          <div class="selector-wrp">
            <source-filter-dropdown v-model="filterRef" :optionList="filterOptions" sourceStyle="dropdown" />
          </div>
        </div>
      </div>
    </template>
    <template #modal-body>
      <div class="filter-selection-content-container">
        <div class="filter-selection-filter-wrp">
          <div v-if="!loading" class="filter-items-wrp">
            <div v-for="(item, index) in filterRef" :key="index" class="dynamic-item">
              {{ item }}
            </div>
          </div>
          <div v-else class="loading">
            <loader-spinner />
          </div>
        </div>

        <!--        TODO: should be in action or footer instead-->
        <div class="filter-selection-item-action-wrp">
          <button class="btn filter-selection-btn-cancel" @click="onCloseModal">{{ t('bi.cancel') }}</button>
          <button
            v-if="JSON.stringify(filterItemsProps) == JSON.stringify(filterRef) || loading"
            class="btn filter-selection-btn-apply"
            type="button"
            disabled
          >
            {{ t('bi.apply') }}
            <span v-if="loading" class="ml-sm spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          </button>
          <div v-else>
            <button class="btn filter-selection-btn-apply" :disabled="loading" @click="onApplyFilter">
              {{ t('bi.apply') }}
            </button>
          </div>
        </div>
      </div>
    </template>
  </base-modal>
</template>

<script lang="ts" setup>
// libs
import { useI18n } from 'vue-i18n';

//component
import BaseModal from '@/views/components/modal/BaseModal.vue';
import LoaderSpinner from '@/views/components/loader/loader-spinner.vue';
import SourceFilterDropdown from '@/views/modules/analytics/components/anal-churnrate/chart-churn-rate/chart-container-filter/SourceFilterDropdown.vue';
import { getDynamicFormattedString, getDynamicLabelValue } from '../../../../utils/bi-utils';
import { computed, ref } from 'vue';

interface Props {
  filterItemsProps: string[];
  filterOptions: Bi.Filter.DynamicOptions | null;
  isOpen: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isOpen: false,
});

const emit = defineEmits(['cancel', 'apply-filter', 'close-modal']);

const { t } = useI18n();

const loading = ref<boolean>(false);

const filterRef = ref<string[]>(props.filterItemsProps);
const onCloseModal = () => {
  emit('close-modal');
};

const onApplyFilter = () => {
  emit('apply-filter', filterRef.value);
};

const totalOptions = () => {
  let optionsCount = 0;
  if (!props.filterOptions) return 0;
  for (let option of props.filterOptions.options) {
    if (option.children) {
      optionsCount += option.children.length;
      if (option.children.length == 0) {
        optionsCount++;
      }
    } else {
      optionsCount++;
    }
  }

  return optionsCount;
};

const totalSelected = computed((): number => {
  if (!props.filterOptions) return 0;
  let selectedOptions = 0;

  for (let option of filterRef.value) {
    const optionParsed = getDynamicFormattedString(option);
    if (parseInt(optionParsed.colIdStr) == 0) {
      const filter = props.filterOptions.options.find((v) => v.id == option);
      if (filter?.children) {
        selectedOptions += filter.children.length;
        if (filter.children.length == 0) {
          selectedOptions++;
        }
      }
    } else {
      selectedOptions++;
    }
  }
  return selectedOptions;
});
</script>

<style lang="scss">
#filter-selection-modal {
  .filter-selection-header-wrp {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 80px;
    .left-wrp {
      height: 100%;
      .title-wrp {
        font-size: 2rem;
        font-weight: 500;
        color: #000;
      }
      .title-desc-wrp {
        font-size: 1.2rem;
        font-weight: 400;
        color: #606a6c;
      }
    }
    .right-wrp {
      text-align: right;
      .counter-wrp {
        margin-bottom: 10px;
        span:first-child {
          font-weight: 500;
        }
      }
    }
  }
  .filter-selection-content-container {
    height: 100%;

    .filter-selection-filter-wrp {
      min-height: 500px;
      background-color: #e5e9ef;
      border-radius: 10px;
      padding: 10px;

      .filter-items-wrp {
        height: 100%;
        width: 100%;
        display: inline-flex;
        gap: 10px;
        flex-wrap: wrap;

        .dynamic-item {
          background-color: #3191ff;
          color: #ffffff;
          font-weight: 400;
          height: 100%;
          white-space: nowrap;
          border-radius: 0.5rem;
          padding: 4px 0.5rem;
          display: flex;
          align-items: center;
          justify-content: center;
          &.active {
            background-color: #012f64;
          }
        }
      }
    }

    .filter-selection-item-action-wrp {
      display: flex;
      justify-content: center;
      align-content: center;
      width: 100%;
      gap: 10px;
      margin-top: 20px;

      .btn {
        border: 1px solid #767676;
        font-size: 18px;
        min-width: 116px;
        color: #767676;
        border-radius: 10px;

        &.filter-selection-btn-apply {
          background-color: #007ffe;
          border-color: #007ffe;
          color: #fff;
        }
      }
    }
  }
}
</style>
